module.exports = __webpack_public_path__ + "static/media/summer.aade0ad3.jpeg";